export const LABOR_REQ_TYPE_OPTIONS = [
  { label: 'Full Time Equivalent (FTE) based', value: 'FTE' },
  { label: 'Relative Value Unit (RVU) based', value: 'RVU' },
];

// [MCV-1541][MCV-1545] The conditionally-required fields seed as null, not 0.
// Seeding 0 satisfied a "has a value" check while leaving the asterisked field
// visibly blank-but-valid, so the wizard advanced with no FTE / RVU figure.
export const emptyLaborMetricsForm = {
  startDate: '',
  endDate: '',
  numOfFtes: null,
  fteShiftsPerYear: 200,
  hoursPerShift: 8,
  minRvusPerShift: null,
  laborReqType: LABOR_REQ_TYPE_OPTIONS[0],
  numRvusReq: null,
};
